<div class="gap-container">
  <div class="cases">
    <mat-tab-group
      *ngIf="loaded; else casesLoading"
      [selectedIndex]="selectedIndex"
      (selectedIndexChange)="onTabChange($event)"
    >
      <mat-tab label="{{'Other cases'| translate}}">
        <ng-container *ngIf="publicCases">
          <app-avaiable-list-case
            *ngIf="showOtherCases; else noOtherCases"
            [cases]="publicCases"
          ></app-avaiable-list-case>
          <ng-template #noOtherCases>
            <p class="without-cases">
              {{ 'You are already enrolled in all available cases' | translate }}
            </p>
          </ng-template>
        </ng-container>
      </mat-tab>
      <mat-tab label="{{'MyClaims'| translate}}">
        <app-your-list-claim></app-your-list-claim>
      </mat-tab>
    </mat-tab-group>

    <ng-template #casesLoading>
      <div class="cases-loading">
        <mat-spinner [mode]="'indeterminate'" diameter="48"></mat-spinner>
      </div>
    </ng-template>
  </div>
</div>
